"use client"

import Link from "next/link"
import { useLanguage } from "@/src/context/LanguageContext"

const content = {
  uk: {
    back: "На головну",
    title: "Політика конфіденційності",
    updated: "Останнє оновлення: 29 квітня 2026 року",
    sections: [
      {
        heading: "1. Загальні положення",
        body: [
          <>
            Ця Політика конфіденційності описує, як ФОП OBELISK (надалі — «Компанія», «ми»),
            що здійснює діяльність у сфері ремонту квартир, будинків та комерційних приміщень
            під ключ у місті Львові, збирає, використовує та захищає персональні дані користувачів
            сайту <span className="text-white">obelisk-remont.com</span>.
          </>,
          "Користуючись нашим сайтом або залишаючи заявку, ви погоджуєтесь з умовами цієї Політики. Якщо ви не погоджуєтесь — будь ласка, не залишайте персональних даних на сайті.",
        ],
        list: null,
      },
      {
        heading: "2. Які дані ми збираємо",
        body: ["Ми збираємо лише ті дані, які необхідні для обробки вашого запиту на ремонт:"],
        list: [
          "Ім'я або назва організації — для персонального звернення та оформлення договору",
          "Номер телефону — для зв'язку з вами та узгодження деталей проєкту",
          "Тип і характеристики приміщення — для підготовки точної комерційної пропозиції",
          "Побажання щодо термінів і пріоритетів — для планування робіт",
          "Додаткові коментарі — якщо ви вирішите їх надати",
        ],
        footer:
          "Також ми автоматично отримуємо технічні дані при відвідуванні сайту: IP-адресу, тип браузера, операційну систему, сторінки, які ви переглядали, та тривалість сесії. Ці дані не ідентифікують вас особисто.",
      },
      {
        heading: "3. Як ми використовуємо ваші дані",
        body: ["Ми використовуємо зібрані дані виключно для:"],
        list: [
          "Зв'язку з вами після залишення заявки та надання консультації",
          "Підготовки індивідуальної комерційної пропозиції на ремонт",
          "Підписання договору та виконання ремонтних робіт",
          "Надсилання інформації про хід робіт, якщо ви є нашим клієнтом",
          "Покращення якості роботи сайту та зручності для користувачів",
        ],
        footer:
          "Ми не продаємо, не передаємо і не розголошуємо ваші персональні дані третім особам без вашої згоди, за винятком випадків, передбачених законодавством України.",
      },
      {
        heading: "4. Cookies та аналітика",
        body: ["Наш сайт використовує cookies — невеликі текстові файли, що зберігаються у вашому браузері. Ми використовуємо їх для:"],
        list: [
          "Коректної роботи технічних функцій сайту",
          "Аналізу відвідуваності (кількість відвідувачів, популярні сторінки)",
          "Покращення навігації та користувацького досвіду",
        ],
        footer:
          "Ви можете відхилити використання cookies через банер при першому відвідуванні сайту, а також вимкнути їх у налаштуваннях браузера. Зверніть увагу, що деякі функції сайту можуть працювати некоректно після відключення cookies.",
      },
      {
        heading: "5. Зберігання та захист даних",
        body: [
          "Ваші дані зберігаються на захищених серверах та обробляються виключно уповноваженими співробітниками Компанії. Ми вживаємо організаційних і технічних заходів для захисту даних від несанкціонованого доступу, зміни, розголошення або знищення.",
          "Дані зберігаються протягом терміну, необхідного для виконання цілей, зазначених у цій Політиці, або до моменту відкликання вами згоди на їх обробку — залежно від того, що настане раніше. Після завершення ремонтних робіт контактні дані клієнтів зберігаються не більше 3 років для гарантійного обслуговування.",
        ],
        list: null,
      },
      {
        heading: "6. Ваші права",
        body: ["Відповідно до законодавства України про захист персональних даних, ви маєте право:"],
        list: [
          "Знати про мету та склад зібраних персональних даних",
          "Отримати доступ до своїх персональних даних",
          "Вимагати виправлення неточних або застарілих даних",
          "Відкликати згоду на обробку даних у будь-який момент",
          "Вимагати видалення своїх персональних даних",
          "Оскаржити дії, пов'язані з обробкою ваших даних",
        ],
        footer:
          "Для реалізації будь-якого з цих прав зверніться до нас за контактами, наведеними нижче. Ми розглянемо ваш запит протягом 10 робочих днів.",
      },
      {
        heading: "7. Зміни до Політики",
        body: [
          "Ми залишаємо за собою право вносити зміни до цієї Політики. Актуальна версія завжди доступна на цій сторінці. Продовження використання сайту після внесення змін означає вашу згоду з оновленою Політикою.",
        ],
        list: null,
      },
    ],
    contactHeading: "8. Контакти",
    contactIntro: "З питань, пов'язаних із захистом персональних даних, звертайтеся до нас:",
    labelCompany: "Компанія:",
    labelAddress: "Адреса:",
    labelEmail: "Email:",
    labelPhone: "Телефон:",
    address: "Львів, вул. І. Франка 45",
  },

  fr: {
    back: "Retour à l'accueil",
    title: "Politique de confidentialité",
    updated: "Dernière mise à jour : 29 avril 2026",
    sections: [
      {
        heading: "1. Dispositions générales",
        body: [
          <>
            La présente Politique de confidentialité décrit la manière dont OBELISK (ci-après — «la
            Société», «nous»), exerçant une activité de rénovation d'appartements, de maisons et de
            locaux commerciaux clé en main, collecte, utilise et protège les données personnelles des
            utilisateurs du site <span className="text-white">obelisk-remont.com</span>.
          </>,
          "En utilisant notre site ou en soumettant une demande, vous acceptez les conditions de la présente Politique. Si vous n'êtes pas d'accord, veuillez ne pas communiquer vos données personnelles sur le site.",
        ],
        list: null,
      },
      {
        heading: "2. Données collectées",
        body: ["Nous collectons uniquement les données nécessaires au traitement de votre demande de rénovation :"],
        list: [
          "Nom ou raison sociale — pour vous adresser personnellement et établir le contrat",
          "Numéro de téléphone — pour vous contacter et convenir des détails du projet",
          "Type et caractéristiques du local — pour préparer un devis précis",
          "Souhaits concernant les délais et priorités — pour la planification des travaux",
          "Commentaires supplémentaires — si vous choisissez d'en fournir",
        ],
        footer:
          "Nous collectons également automatiquement des données techniques lors de votre visite : adresse IP, type de navigateur, système d'exploitation, pages consultées et durée de la session. Ces données ne permettent pas de vous identifier personnellement.",
      },
      {
        heading: "3. Utilisation de vos données",
        body: ["Nous utilisons les données collectées exclusivement pour :"],
        list: [
          "Vous contacter après réception de votre demande et vous fournir une consultation",
          "Préparer un devis personnalisé pour votre rénovation",
          "Signer le contrat et réaliser les travaux de rénovation",
          "Vous informer de l'avancement des travaux si vous êtes notre client",
          "Améliorer la qualité et l'ergonomie du site",
        ],
        footer:
          "Nous ne vendons, ne transmettons ni ne divulguons vos données personnelles à des tiers sans votre consentement, sauf dans les cas prévus par la réglementation applicable (notamment le RGPD et la loi Informatique et Libertés).",
      },
      {
        heading: "4. Cookies et analyse",
        body: ["Notre site utilise des cookies — de petits fichiers texte stockés dans votre navigateur. Nous les utilisons pour :"],
        list: [
          "Le bon fonctionnement des fonctions techniques du site",
          "L'analyse de fréquentation (nombre de visiteurs, pages populaires)",
          "L'amélioration de la navigation et de l'expérience utilisateur",
        ],
        footer:
          "Vous pouvez refuser l'utilisation des cookies via la bannière affichée lors de votre première visite, ainsi que les désactiver dans les paramètres de votre navigateur. Veuillez noter que certaines fonctionnalités du site peuvent ne pas fonctionner correctement après la désactivation des cookies.",
      },
      {
        heading: "5. Conservation et sécurité des données",
        body: [
          "Vos données sont stockées sur des serveurs sécurisés et traitées exclusivement par des collaborateurs habilités de la Société. Nous mettons en œuvre des mesures organisationnelles et techniques pour protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction.",
          "Les données sont conservées pendant la durée nécessaire à la réalisation des finalités décrites dans la présente Politique, ou jusqu'au retrait de votre consentement — selon ce qui survient en premier. Après l'achèvement des travaux, les coordonnées des clients sont conservées au maximum 3 ans aux fins de service après-vente et de garantie.",
        ],
        list: null,
      },
      {
        heading: "6. Vos droits (RGPD)",
        body: ["Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez des droits suivants :"],
        list: [
          "Droit d'accès à vos données personnelles",
          "Droit de rectification des données inexactes ou incomplètes",
          "Droit à l'effacement («droit à l'oubli»)",
          "Droit à la limitation du traitement",
          "Droit à la portabilité de vos données",
          "Droit d'opposition au traitement",
          "Droit de retirer votre consentement à tout moment",
          "Droit d'introduire une réclamation auprès de la CNIL (www.cnil.fr)",
        ],
        footer:
          "Pour exercer l'un de ces droits, contactez-nous aux coordonnées ci-dessous. Nous répondrons à votre demande dans un délai de 30 jours.",
      },
      {
        heading: "7. Modifications de la Politique",
        body: [
          "Nous nous réservons le droit de modifier la présente Politique. La version en vigueur est toujours disponible sur cette page. La poursuite de l'utilisation du site après modification vaut acceptation de la Politique mise à jour.",
        ],
        list: null,
      },
    ],
    contactHeading: "8. Contact",
    contactIntro: "Pour toute question relative à la protection de vos données personnelles, contactez-nous :",
    labelCompany: "Société :",
    labelAddress: "Adresse :",
    labelEmail: "E-mail :",
    labelPhone: "Téléphone :",
    address: "Lviv, rue I. Franka 45, Ukraine",
  },
}

export default function PrivacyPolicyContent() {
  const { lang } = useLanguage()
  const c = content[lang]

  return (
    <main className="min-h-screen bg-black text-white">
      <div className="container mx-auto px-4 py-16 md:py-24 max-w-3xl">

        <Link
          href="/"
          className="inline-flex items-center text-gray-400 hover:text-white transition-colors text-sm mb-10 group"
        >
          <svg
            className="w-4 h-4 mr-2 transition-transform group-hover:-translate-x-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          {c.back}
        </Link>

        <h1 className="text-3xl md:text-4xl font-medium mb-3">{c.title}</h1>
        <p className="text-gray-500 text-sm mb-12">{c.updated}</p>

        <div className="space-y-10 text-gray-300 font-light leading-relaxed">

          {c.sections.map((section) => (
            <section key={section.heading}>
              <h2 className="text-white font-medium text-xl mb-4">{section.heading}</h2>
              {section.body.map((para, i) => (
                <p key={i} className={i > 0 ? "mt-3" : ""}>{para}</p>
              ))}
              {section.list && (
                <ul className="space-y-2 list-none mt-3">
                  {section.list.map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-gray-500 flex-shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
              )}
              {"footer" in section && section.footer && (
                <p className="mt-4">{section.footer}</p>
              )}
            </section>
          ))}

          <section>
            <h2 className="text-white font-medium text-xl mb-4">{c.contactHeading}</h2>
            <p className="mb-4">{c.contactIntro}</p>
            <div className="space-y-2">
              <p>
                <span className="text-gray-500">{c.labelCompany}</span>{" "}
                <span className="text-white">OBELISK</span>
              </p>
              <p>
                <span className="text-gray-500">{c.labelAddress}</span>{" "}
                {c.address}
              </p>
              <p>
                <span className="text-gray-500">{c.labelEmail}</span>{" "}
                <a href="mailto:obelisk79011@gmail.com" className="text-white hover:text-gray-300 transition-colors">
                  obelisk79011@gmail.com
                </a>
              </p>
              <p>
                <span className="text-gray-500">{c.labelPhone}</span>{" "}
                <a href="tel:+380636644132" className="text-white hover:text-gray-300 transition-colors">
                  +38 063 664 41 32
                </a>
              </p>
            </div>
          </section>

        </div>
      </div>
    </main>
  )
}
